import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Globals } from './../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class SyncService {
  private syncServiceUrl: string;
  private settingsUrl: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.syncServiceUrl = globals.url + 'syncthing/';
    this.settingsUrl = globals.url + 'c3cloud-settings/';
  }

  public getSyncStats() {
    return this.http
      .get(this.syncServiceUrl + 'stats')
      .map((response: Response) => response.json());
  }
  public getConnections() {
    return this.http
      .get(this.syncServiceUrl + 'connections')
      .map((response: Response) => response.json());
  }
  public getAllConnectivities(filters?, count?) {
    let url = this.syncServiceUrl + 'connectivities';
    const params: URLSearchParams = new URLSearchParams();
    if (
      filters &&
      Object.keys(filters).length !== 0 &&
      filters.constructor === Object
    ) {
      Object.keys(filters).forEach((filter) => {
        params.set(filter, filters[filter] + '');
      });
    }
    if (count) { params.set('count', 'true'); }
    const paramsStr = params.toString();
    if (paramsStr) { url += '?' + paramsStr; }
    return this.http.get(url).map((response: Response) => response.json());
  }

  // 1 device
  public getDeviceStats(deviceId: string) {
    return this.http
      .get(this.syncServiceUrl + 'devices/' + deviceId + '/stats')
      .map((response: Response) => response.json());
  }
  public getDeviceCompletions(deviceId: string) {
    return this.http
      .get(this.syncServiceUrl + 'devices/' + deviceId + '/completions')
      .map((response: Response) => response.json());
  }
  public getDevicesCompletions(filters, count?) {
    let url = this.syncServiceUrl + 'devices/all/completions';

    if (typeof filters !== 'undefined') {
      Object.keys(filters).forEach((filter, i) => {
        if (i == 0) { url += '?' + filter + '=' + filters[filter]; } else { url += '&' + filter + '=' + filters[filter]; }
      });
      if (count) { url += '&count=true'; }
    } else if (count) { url += '?count=true'; }

    return this.http
      .get(url)
      .map((response: Response) => response.json());
  }
  public getDeviceConnections(deviceId: string) {
    return this.http
      .get(this.syncServiceUrl + 'devices/' + deviceId + '/connections')
      .map((response: Response) => response.json());
  }
  public getDeviceConnectivities(deviceId: string) {
    return this.http
      .get(this.syncServiceUrl + 'connectivities/' + deviceId)
      .map((response: Response) => response.json());
  }

  // Sync Manager
  public getInstances() {
    return this.http.get(this.syncServiceUrl + 'instances').map((response: Response) => response.json());
  }
  public getInstancesConnections() {
    return this.http.get(this.syncServiceUrl + 'instances/connections').map((response: Response) => response.json());
  }
  public getInstanceSettings(id) {
    return this.http.get(this.syncServiceUrl + id + '/settings').map((response: Response) => response.json());
  }
  public setInstanceSettings(id, settings) {
    return this.http.post(this.syncServiceUrl + id + '/settings', settings).map((response: Response) => response.json());
  }
  public autoBalance() {
    return this.http.put(this.syncServiceUrl + 'instances/autoBalance', null).map((response: Response) => response.json());
  }

  public instanceAction(id, action) {
    return this.http.post(this.syncServiceUrl + id + '/action', { action }).map((response: Response) => response.json());
  }
  // Sync settings
  public getSettings() {
    return this.http.get(this.settingsUrl).map((response: Response) => response.json());
  }
  public setSettings(settings) {
    return this.http.post(this.settingsUrl, settings).map((response: Response) => response.json());
  }
}
